import React, { Component } from "react";
import { Button } from "react-bootstrap";
import cx from "classnames";
import PropTypes from "prop-types";

class ProgressButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fill, simple, pullRight, round, block, ...rest } = this.props;

    const btnClasses = cx({
      "btn-fill": fill,
      "btn-simple": simple,
      "pull-right": pullRight,
      "btn-block": block,
      "btn-round": round
    });

    var {runningAsyncOperation, ...other} = this.props;

    if (this.props.runningAsyncOperation) {
      return <Button disabled style={{minWidth:80, maxHeight:40}} className={btnClasses} {...other}><span className="spinner-border spinner-border" role="status" aria-hidden="true"></span>
            {this.props.waitingText?<span style={{marginLeft:15,verticalAlign:'text-bottom'}}>{this.props.waitingText}</span>:''}
            </Button>;
    }else{
      return <Button style={{minWidth:80, maxHeight:40}} className={btnClasses} {...other} />;
    }
  }

  setAsyncOperationStarted = () => {
    this.setState({ runningAsyncOperation : true });
  }
}

ProgressButton.propTypes = {
  fill: PropTypes.bool,
  simple: PropTypes.bool,
  pullRight: PropTypes.bool,
  block: PropTypes.bool,
  round: PropTypes.bool
};

export default ProgressButton;
